module.exports = __webpack_public_path__ + "img/13.5dab89a7.jpg";